module.exports = __webpack_public_path__ + "static/media/crazy_example.15836000.png";